var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWhiteWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFB74D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "black",
    fillOpacity: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.49L24.03 23.5H8.97L16.5 10.49ZM16.5 6.5L5.5 25.5H27.5L16.5 6.5ZM17.5 20.5H15.5V22.5H17.5V20.5ZM17.5 14.5H15.5V18.5H17.5V14.5Z",
    fill: "#FFB74D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.49L24.03 23.5H8.97L16.5 10.49ZM16.5 6.5L5.5 25.5H27.5L16.5 6.5ZM17.5 20.5H15.5V22.5H17.5V20.5ZM17.5 14.5H15.5V18.5H17.5V14.5Z",
    fill: "white",
    fillOpacity: 0.6
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWhiteWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/whiteWarning.7197d0336e8f212395218df17586ecb6.svg";